const usernameRegex = "^[a-zA-Z0-9_&]*$";

export { usernameRegex };
